export default (() => {
    const observer = new MutationObserver(mutationsList => {
        for (const mutation of mutationsList) {
            if (mutation.attributeName === 'data-theme') {
                const theme = (mutation.target as Element).getAttribute('data-theme')
                if (theme) {
                    const simpleTheme = theme.replace('theme-', '')
                    const root = document.documentElement
                    root.classList.remove('light', 'dark')
                    root.classList.add(simpleTheme)
                }
            }
        }
    })

    const options = { attributes: true }

    observer.observe(document.querySelector('html'), options)
})()
